<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('edit')}} {{t('assessment')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Assessments')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/vulnerability/assessments" class="d-inline-block position-relative">
                    {{t('Management')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('edit')}} {{t('assessment')}}
            </li>
        </ol>
    </div>

    <!-- Edit Assessment -->
    <mat-card class="altair-card create-company-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-content>
            <form [formGroup]="editAssessmentForm">
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('name')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-name')}}
                                </mat-label>
                                <input matInput type="text" id="assessmentName" formControlName="assessmentName"
                                    [(ngModel)]="editAssessment.assessmentName" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('description')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-description')}}
                                </mat-label>
                                <input matInput type="text" id="description" formControlName="description"
                                    [(ngModel)]="editAssessment.description">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('severity')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-severity')}}
                                </mat-label>
                                <mat-select formControlName="severity" [(value)]="selectedSeverity" required>
                                    <mat-option *ngFor="let severity of severities" [value]="severity">
                                        {{severity.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('enter-a-date-range')}}
                            </label>
                            <mat-form-field>
                                <mat-date-range-input [formGroup]="editAssessmentForm" [rangePicker]="picker">
                                    <input matStartDate formControlName="startDate"
                                        [(ngModel)]="editAssessment.startDate" placeholder="{{t('start-date')}}">
                                    <input matEndDate formControlName="endDate" [(ngModel)]="editAssessment.endDate"
                                        placeholder="{{t('end-date')}}">
                                </mat-date-range-input>
                                <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                                @if (editAssessmentForm.get('startDate')!.hasError('matStartDateInvalid')) {
                                <mat-error>{{t('invalid-start-date')}}</mat-error>
                                }
                                @if (editAssessmentForm.get('endDate')!.hasError('matEndDateInvalid')) {
                                <mat-error>{{t('invalid-end-date')}}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('company')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-company')}}
                                </mat-label>
                                <mat-select [(value)]="selectedCompany"
                                    (selectionChange)="changeCompany(selectedCompany)" required>
                                    <mat-option *ngFor="let company of companies" [value]="company.id">
                                        {{company.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('branch-office')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-branch-office')}}
                                </mat-label>
                                <mat-select formControlName="branchOffice" [(value)]="selectedBranchOffice"
                                    (selectionChange)="changeBranchOffice()" required>
                                    <mat-option *ngFor="let branchOffice of branchOffices" [value]="branchOffice">
                                        {{branchOffice.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('vulnerability-origin')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-vulnerability-origin')}}
                                </mat-label>
                                <mat-select formControlName="vulnerabilityOrigin"
                                    [(value)]="selectedVulnerabilityOrigin">
                                    <mat-option *ngFor="let vulnerabilityOrigin of vulnerabilityOrigins"
                                        [value]="vulnerabilityOrigin">
                                        {{vulnerabilityOrigin.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('company-users-list')}}
                            </label>
                            <mat-selection-list formControlName="companyUsers" [(ngModel)]="editAssessment.companyUsers" #usersList>
                                @for (companyUser of companyUsersList; track companyUser) {
                                <mat-list-option value="{{companyUser.id}}">{{companyUser.name}}</mat-list-option>
                                }
                            </mat-selection-list>
                            <p>
                                {{t('company-users-selected')}}: {{usersList.selectedOptions.selected.length}}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="btn-box">
                    <button mat-button type="button" (click)="onSubmit()" [disabled]="editAssessmentForm.invalid">
                        {{t('save')}} {{t('assessment')}}
                    </button>
                    <a mat-button routerLink="/vulnerability/assessments">
                        {{t('cancel')}}
                    </a>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-container>
